import { useAuth0 } from '@auth0/auth0-react';

const useAuthState = () => {
  const { isAuthenticated, user, isLoading } = useAuth0();
  
  return {
    isAuthenticated,
    user,
    isLoading
  };
};

export default useAuthState;
